module.exports = __webpack_public_path__ + "img/zte.52124205.svg";